import { Token } from "../api/pools";
import { useAppSelector } from "../redux";

interface UsdcTokenInfo {
  address: string;
  decimals: number;
  symbol: string;
  token: Token;
}

export const useTokenData = (symbol: string): UsdcTokenInfo => {
  const chainId = useAppSelector((state) => state.ui.chainId);
  const supportedChains = useAppSelector(
    (state) => state.settings.supportedChains
  );

  const currentChain = supportedChains.find(
    (chain) => Number(chain.chainId) === chainId
  );

  const usdcToken = currentChain?.tokens.find(
    (token) => token.token === symbol
  );

  if (!currentChain || !usdcToken) {
    const polygonChain = supportedChains.find(
      (chain) => Number(chain.chainId) === 137
    );
    const defaultUsdcToken = polygonChain?.tokens.find(
      (token) => token.token === symbol
    );

    if (!defaultUsdcToken) {
      return {
        address: "0x",
        decimals: 6,
        symbol: "",
        token: Token.USDC,
      };
    }

    return {
      address: defaultUsdcToken.address,
      decimals: defaultUsdcToken.decimals,
      symbol: defaultUsdcToken.symbol,
      token: defaultUsdcToken.token,
    };
  }

  return {
    address: usdcToken.address,
    decimals: usdcToken.decimals,
    symbol: usdcToken.symbol,
    token: usdcToken.token,
  };
};
